var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXWatermarkDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 831",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.9165 1438.25H372.816L719.761 1077.42L1066.92 1438.88H1448.33L719.148 680.285L-5.9165 1438.25Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1448.33 -627.362H1069.55L722.65 -266.539L375.487 -628H-5.9165L723.263 130.599L1448.33 -627.362Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1703.76 966.382V763.12L1357.03 402.069L1704.37 40.8358V-159.146L1514.35 -158.28L975.411 402.707L1514.22 960.914L1703.76 966.382Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-281.759 -159.146V44.162L64.9675 405.213L-282.372 766.446V966.382L-92.3049 965.562L446.633 404.575L-92.1736 -153.632L-281.759 -159.146Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWatermarkDesktop);
export default __webpack_public_path__ + "static/media/x-watermark-desktop.50d827177868d9c561255f156aa01ab2.svg";
export { ForwardRef as ReactComponent };